import Title from "../title/Title";
import DeeplinkIcon from "./img/deeplinkIcon.svg";
import ModalCloseButton from "./ModalCloseButton";

export default function DeeplinkModalHeader({ title, subtitle, onClose }) {
  return (
    <div className="user-modal-header">
      <div className="user-modal-header-contents">
        <div className="icon-button-container">
          <div className="icon-container">
            <img
              style={{ margin: "auto" }}
              src={DeeplinkIcon}
              alt=""
              loading="lazy"
            />
          </div>
          <div className="x-button-container">
            <ModalCloseButton
              onClick={onClose}
              className="user-x-button edit-institution-close"
            />
          </div>
        </div>
        <div className="user-modal-header-title">
          <Title
            title={title}
            subtitle={subtitle}
            titleSize="1.125rem"
            subtitleSize="0.875rem"
            gap="0.25rem"
            lineHeight="1.75rem"
          />
        </div>
      </div>
    </div>
  );
}
